<template>
    <div class="hero-section d-flex align-items-center justify-content-center loading-overlay">
        <div class="text-center text-danger">
            <div class="mb-2">
                <div class="spinner-border text-dark1" style="width: 4rem; height: 4rem;" role="status">
                    <span class="visually-hidden">{{ TR.loading }}...</span>
                </div>
            </div>
            <h1 class="font-display display-3 fw-bold mb-2 text-glow1">
                <!-- {{ G.projectName }} -->
                  <img src="/assets/images/logo_red.png" style="height: 80px;" />
            </h1>
            <p class="lead mb-4 text-dark1">{{ TR.loading }}...</p>
            <div class="loading-dots">
                <div class="loading-dot"></div>
                <div class="loading-dot"></div>
                <div class="loading-dot"></div>
            </div>
        </div>
    </div>
</template>


<script>
import { ref, watchEffect } from 'vue';
import { useStore } from '@/system_modules/store';

import { G } from '@/_common';

export default {
    name: "LoadingC",
    setup() {
        const store = useStore();
        const TR = ref();

        watchEffect(() => {
            TR.value = store.getTranslation();
        });

        return {
            G,
            TR,
        };
    },
}
</script>

<style lang="scss" scoped>
.loading-overlay{
    width: 100%;
    height: 100%;
    border-radius: 20px;
    position: absolute;
    left: 0;
    top: 0;
    background: var(--background-gradient);
}
</style>